const UserMessage = ({ message, index }) => {
  return (
    <div className="flex justify-end">
      <div
        key={index}
        className="text-gray-900 bg-success-50 w-3/4 border border-gray-500 rounded-md p-4 "
      >
        <div>{message.content}</div>
      </div>
    </div>
  );
};

export default UserMessage;
